// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1TimestampSchema = z.object({
  id: z.number().int(),
  hour_id: z.number().int(),
  from: z.coerce.string(),
  to: z.coerce.string(),
  entry_ids: z.array(z.number().int()),
});
